import React from 'react';
import './LanguageSelector.less';
import BrandIcon from '../BrandIcon/BrandIcon';
import { showAlertWithOptions } from '../../../utils';
import {
  getTexts,
  LocalizePropType,
  selectBrandSettings,
  selectDeviceLanguage,
  selectUser,
  setLanguage,
  updateUser,
  useInitializeLanguage,
  withTextLocalizer,
} from 'getaway-data-layer';
import { useDispatch, useSelector } from 'react-redux';
import config from '../../../env.config';
import { useQuery } from '../../../hooks/useQuery';

type Props = {
  localize: LocalizePropType;
  showSelectedLanguage: boolean;
  white: boolean;
};

const languageFlagMap: Record<string, string> = {
  en: 'GB',
  de: 'DE',
  fr: 'FR',
  it: 'IT',
  pl: 'PL',
  sk: 'SK',
  cz: 'CZ',
  tr: 'TR',
};

const LanguageSelector = ({ showSelectedLanguage, white, localize }: Props) => {
  const dispatch = useDispatch();
  const query = useQuery();
  const brandSettings = useSelector(selectBrandSettings);
  const allowedLanguages = brandSettings?.allowedLanguages || [];
  const user = useSelector(selectUser);
  const xBrandId = config.brand.xBrandId;
  const savedLang = useSelector(selectDeviceLanguage);
  const deviceLang = navigator?.language?.slice(0, 2)?.toLowerCase() || '';
  const forcedLang = query?.get('locale');

  useInitializeLanguage({
    xBrandId,
    brandSettings,
    user,
    deviceLang,
    savedLang,
    forcedLang,
  });

  const showLanguageDialog = () => {
    const options = allowedLanguages.map((lang) => {
      const lg = lang === 'deformal' ? 'de' : lang;
      const countryCode = languageFlagMap?.[lg] || lg;
      return {
        title: localize(`language.dialog.${lg}`),
        selected: savedLang === lang,
        icon: countryCode
          ? `http://purecatamphetamine.github.io/country-flag-icons/3x2/${countryCode}.svg`
          : undefined,
        action: () => {
          dispatch(setLanguage(lang));
          setTimeout(() => dispatch(getTexts()), 500);
          if (user) {
            dispatch(updateUser({ locale: lang }));
          }
        },
      };
    });

    showAlertWithOptions(localize('language.dialog.title'), '', options);
  };

  const displayLanguage = savedLang === 'deformal' ? 'de' : savedLang;

  return (
    allowedLanguages.length > 1 && (
      <div
        data-testid="LanguageSelector-switchLang"
        className="language-container"
        style={white ? { opacity: 1 } : {}}
        onClick={showLanguageDialog}
      >
        <BrandIcon
          name={white ? 'languageWhite' : 'language'}
          style={{ width: 24, height: 24, marginRight: 3 }}
        />
        {showSelectedLanguage && displayLanguage?.toUpperCase()}
      </div>
    )
  );
};

LanguageSelector.defaultProps = {
  showSelectedLanguage: true,
  white: false,
};

export default React.memo(withTextLocalizer(LanguageSelector));
